import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app-section" }
const _hoisted_2 = { id: "app" }

import { onMounted } from 'vue'
import CollectivitesSidebar from '@/components/collectivites/CollectivitesSidebar.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'CollectivitesLayout',
  setup(__props) {

function toggleSidebar() {
  const sidebar = document.querySelector('.sidebar')
  if (sidebar) {
    sidebar.classList.toggle('close')
  }
}

onMounted(() => {
  // Écouter les clics sur les boutons sidebar externes
  document.addEventListener('click', (e) => {
    const target = e.target as HTMLElement
    if (target.closest('.sidebar-icon.open')) {
      toggleSidebar()
    }
  })
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("main", null, [
    _createVNode(CollectivitesSidebar),
    _createElementVNode("section", _hoisted_1, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "page-space-50" }, null, -1)),
      _createElementVNode("div", {
        class: "sidebar-icon open show-mobile mb-5",
        onClick: toggleSidebar
      }, [...(_cache[0] || (_cache[0] = [
        _createElementVNode("div", { class: "barr1" }, null, -1),
        _createElementVNode("div", { class: "barr2" }, null, -1),
        _createElementVNode("div", { class: "barr3" }, null, -1)
      ]))]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_view)
      ])
    ])
  ]))
}
}

})